export function getAffiliateURL() {
  if (typeof window !== 'undefined' && 'location' in window) {
    return `https://happyreact.com/?utm_source=${window.location.origin}&utm_medium=widget&utm_campaign=footer`;
  }

  return `https://happyreact.com/?utm_source=feedback&utm_medium=widget&utm_campaign=footer`;
}
